// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum BusinessTypes {
  AUTOMATION = 65,
  FIRE = 70,
  SECURITY = 83,
  SERVICE_AGREEMENT = 84,
  ELECTRICAL = 69,
  MECHANICAL = 77,
}
